<template>
  <component :is="getTagFromPhone">
    <a
      v-if="tagName === 'A'"
      class="cc-phone cc-phone_visible"
      :href="`callto:${Number(phone.replace(/\D+/g, ''))}`"
    >{{ phone }}</a>
    <span
      v-else
      class="cc-phone cc-phone_visible"
    >{{ phone }}</span>
  </component>
</template>

<script>
import Vue from 'vue';
import { getters as cityGetters } from '../../store/city.store';

const CITIES_API_URL = citiesApiUrl;// eslint-disable-line
const axios = require('axios');

const contactCenterPhoneGetValue = function (cityCode) {
  return axios.get(`${CITIES_API_URL}/${cityCode}/phone`);
};

const contactCenterPhone = {
  name: 'ContactCenterPhone',
  watch: {
    phoneContact(newVal) {
      if (newVal) {
        this.phone = newVal;
      }
    },
  },
};

const factory = function () {
  const contactCenterPhoneValue = Vue.observable({
    Phone: '',
  });

  const cityCode = cityGetters.code();
  if (cityCode) {
    contactCenterPhoneGetValue(cityGetters.code())
      .then((resp) => {
        contactCenterPhoneValue.Phone = resp.data.phone;
      });
  }


  /**
   *  Создаем instance для прослушивания изменения выбранного пользователем города,
   *  При смене города пользователя сделаем одни запрос для всех view номера телефона и обновим значение contactCenterPhoneValue
   */

  function listenerChangeCitySelected() {
    const listenerInstance = new Vue({
      computed: {
        ...cityGetters,
        selectedCity() {
          return { Code: cityGetters.code(), Name: cityGetters.name() };
        },
      },
      watch: {
        selectedCity: {
          handler(newVal) {
            contactCenterPhoneGetValue(newVal.Code)
              .then((resp) => {
                contactCenterPhoneValue.Phone = resp.data.phone;
              });
          },
          deep: true,
        },
      },
    });
    return listenerInstance;
  }

  function renderContactCenterPhone($container, tagName) {
    const instance = new Vue({
      ...contactCenterPhone,
      computed: {
        ...contactCenterPhoneValue,
        phoneContact() {
          return contactCenterPhoneValue.Phone;
        },
        getTagFromPhone() {
          return (this.phoneContact.indexOf('800') === -1) ? 'span' : 'noindex';
        },
      },
      data() {
        return {
          tagName,
          phone: '',
        };
      },
    });
    instance.$mount($container);

    return instance;
  }

  const phoneContainers = document.getElementsByClassName('cc-phone');
  Array.prototype.forEach.call(phoneContainers, (el) => {
    renderContactCenterPhone(el, el.tagName);
  });
  listenerChangeCitySelected();
};

export { contactCenterPhone as default, factory };
</script>

<style lang="scss">
  .cc-phone {
    opacity: 0;
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
    font-style: inherit;
  }
</style>

<style lang="scss" scoped>
  .cc-phone {

    &_visible {
      opacity: 1;
    }
  }

  a.cc-phone {
    /*@media (max-width: 767px) { maybe mobile? */
    color: #3681c7;
    /*}*/
  }
</style>
